import theme from '@styles/theme';
export default {
  showroomOffer: {
    p: ['64px 16px', '80px 24px', '80px 24px', '116px 195px'],
    backgroundColor: theme.rawColors.beige300,
    h2: {
      p: ['0 16px 40px', '0 16px 40px', '0 16px 48px', '0 0 48px']
    },
    div: {
      fontFamily: theme.fonts.uniform,
      fontWeight: theme.fontWeights.normal,
      lineHeight: '175%',
      'h1, h2, h3, h4, h5, h6': {
        fontFamily: theme.fonts.uniform,
        mt: 40,
        mb: 16,
        fontWeight: theme.fontWeights.normal,
        '&:first-of-Type': {
          mt: 'unset'
        },
        '&:first-letter': {
          textTransform: 'uppercase'
        }
      },
      h1: {
        fontSize: theme.fontSizes.h1
      },
      h2: {
        fontSize: theme.fontSizes.h2
      },
      h3: {
        fontSize: theme.fontSizes.h3
      },
      h4: {
        fontSize: theme.fontSizes.h4
      },
      h5: {
        fontSize: theme.fontSizes.h5
      },
      h6: {
        fontSize: theme.fontSizes.h6
      }
    }
  }
};